import { render } from "./picksColorPicker.vue?vue&type=template&id=3fafd1ca&scoped=true"
import script from "./picksColorPicker.vue?vue&type=script&lang=js"
export * from "./picksColorPicker.vue?vue&type=script&lang=js"

import "./picksColorPicker.vue?vue&type=style&index=0&id=3fafd1ca&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fafd1ca"]])

export default __exports__